var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 24 / icon_lock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 14.6269C13.3127 14.352 13.51 13.9491 13.51 13.5C13.51 12.6716 12.8384 12 12.01 12H12C11.1716 12 10.5 12.6716 10.5 13.5C10.5 13.9443 10.6931 14.3434 11 14.6181V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V14.6269Z",
    fill: "#E30031"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C9.23858 1 7 3.23858 7 6V8C5.34315 8 4 9.34315 4 11V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V11C20 9.34315 18.6569 8 17 8V6C17 3.23858 14.7614 1 12 1ZM15 8V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V8H15ZM6 11C6 10.4477 6.44772 10 7 10H17C17.5523 10 18 10.4477 18 11V19C18 19.5523 17.5523 20 17 20H7C6.44772 20 6 19.5523 6 19V11Z",
    fill: "#E30031"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon_lock.c2e7dcd9ce8456bbad91a013fa0f7cdc.svg";
export { ForwardRef as ReactComponent };